import React, { useEffect, useState } from "react";
import { YearSelection } from "../../utils/Helper";
import { FormattedMessage } from "react-intl";

const YearModel = ({ setCurrentYearSelected, currentYearSelected }: any) => {
  const years: any = YearSelection();
  const [selectedYear, setSelectedYear] = useState<number>(currentYearSelected);

  useEffect(() => {
    $(".btnClose").click();
    $(".modal-backdrop").remove();
  }, [setCurrentYearSelected]);

  const handleSelectedYear = (year: any) => {
    setSelectedYear(year);
    setCurrentYearSelected(year);
  };

  return (
    <>
      <div
        className="modal modelStyle fade"
        id="yearModel"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <FormattedMessage id="Select_Year" />
              </h1>
              {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
              <button
                type="button"
                className="btn p-0 f-20 btnClose"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="icon-close"></span>
              </button>
            </div>
            <div className="modal-body">
              <ul className="yearList">
                {years?.map((item: any) => {
                  return (
                    <li
                      key={item}
                      className={item === selectedYear ? "active" : ""}
                      onClick={(e: any) => handleSelectedYear(item)}
                    >
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
            {/* <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" className="btn btn-primary">Save changes</button>
                </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default YearModel;
